import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import BusinessIcon from "@mui/icons-material/Business";
import HandshakeIcon from "@mui/icons-material/Handshake";
import { useMediaQuery, IconButton } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { fadeUp } from "../config/animations";
import { motion } from "framer-motion";

const partners = [
  {
    name: "FlyHi Trans",
    description:
      "FlyHi Trans is our dedicated logistics partner, specializing in fast, reliable, and tech-enabled transportation solutions. From fleet dispatch to real-time tracking, they ensure your goods move with precision and care.",
    icon: <LocalShippingIcon sx={{ fontSize: 60, color: "#1976d2" }} />,
  },
  {
    name: "Partner B",
    description:
      "A strategic collaborator helping us expand our service reach and deliver consistent quality across regions.",
    icon: <BusinessIcon sx={{ fontSize: 60, color: "#1976d2" }} />,
  },
  {
    name: "Partner C",
    description:
      "Trusted in operations and support, Partner C brings deep expertise and reliability to our ecosystem.",
    icon: <HandshakeIcon sx={{ fontSize: 60, color: "#1976d2" }} />,
  },
  {
    name: "Partner C",
    description:
      "Trusted in operations and support, Partner C brings deep expertise and reliability to our ecosystem.",
    icon: <HandshakeIcon sx={{ fontSize: 60, color: "#1976d2" }} />,
  },
  {
    name: "Partner C",
    description:
      "Trusted in operations and support, Partner C brings deep expertise and reliability to our ecosystem.",
    icon: <HandshakeIcon sx={{ fontSize: 60, color: "#1976d2" }} />,
  },
  {
    name: "Partner C",
    description:
      "Trusted in operations and support, Partner C brings deep expertise and reliability to our ecosystem.",
    icon: <HandshakeIcon sx={{ fontSize: 60, color: "#1976d2" }} />,
  },
];

const Partners = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [index, setIndex] = useState(0);
  const timerRef = useRef(null);

  const startTimer = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setIndex((prev) => (prev + 1) % partners.length);
    }, 5000);
  };

  useEffect(() => {
    startTimer();
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  const handlePrev = () => {
    setIndex((prev) => (prev - 1 + partners.length) % partners.length);
    startTimer();
  };

  const handleNext = () => {
    setIndex((prev) => (prev + 1) % partners.length);
    startTimer();
  };

  return (
    <Box
      id="partners"
      sx={{
        position: "relative",
        minHeight: "100vh",
        backgroundImage:
          "url('https://cdn.sanity.io/images/yk5gp8um/prod/2bfdb6e79211d931344d574cf773b94dd4690b20-3600x2160.jpg?w=1280&h=720&auto=format')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Vignette Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 1,
          background: `
            radial-gradient(
              ellipse at center,
              rgba(0,0,0,0.25) 0%,
              rgba(0,0,0,0.45) 60%,
              rgba(0,0,0,0.65) 100%
            )
          `,
        }}
      />

      {/* Content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          py: 10,
          px: {xs:1,lg:4},
        }}
      >
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ color: "#fff", textShadow: "0 2px 12px #000" }}
        >
          Our Partners
        </Typography>

        <motion.div initial="hidden" animate="visible" variants={fadeUp}>
          {isMobile ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                mt: 0,
              }}
            >
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  width: 300,
                  height: 500,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  borderRadius: 3,
                  boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
                  overflow: "hidden",
                }}
              >
                {partners[index].icon}
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    fontWeight: 700,
                    mt: 1,
                    letterSpacing: 0.5,
                    color: "#333",
                  }}
                >
                  {partners[index].name}
                </Typography>
                <Typography color="text.secondary" sx={{ fontSize: "1.1rem" }}>
                  {partners[index].description}
                </Typography>
              </Paper>

              {/* Progress Bars */}
              <Box sx={{ display: "flex", gap: 1, mt: 3 }}>
                {partners.map((_, i) => (
                  <Box
                    key={i}
                    sx={{
                      width: 30,
                      height: 6,
                      borderRadius: 3,
                      backgroundColor:
                        i === index ? "#1976d2" : "rgba(255,255,255,0.5)",
                      transition: "background-color 0.3s ease",
                    }}
                  />
                ))}
              </Box>

              {/* Navigation Buttons */}
              <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                <IconButton
                  onClick={handlePrev}
                  sx={{ color: "#fff" }}
                  aria-label="Previous partner"
                >
                  <ArrowBackIosNewIcon />
                </IconButton>
                <IconButton
                  onClick={handleNext}
                  sx={{ color: "#fff" }}
                  aria-label="Next partner"
                >
                  <ArrowForwardIosIcon />
                </IconButton>
              </Box>
            </Box>
          ) : (
            <Grid container spacing={4} justifyContent="center">
              {partners.map((partner, i) => (
                <Grid item xs={12} sm={6} md={3} key={i}>
                  <Paper
                    elevation={6}
                    sx={{
                      p: 3,
                      height: 350,
                      width: 250,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                      backdropFilter: "blur(8px)",
                      backgroundColor: "rgba(255, 255, 255, 0.77)",
                      borderRadius: 3,
                      boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
                      overflow: "hidden",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      transformOrigin: "center bottom",
                      "&:hover": {
                        transform: "translateY(-6px)",
                        boxShadow: "0 12px 24px rgba(0,0,0,0.4)",
                        zIndex: 10,
                      },
                    }}
                  >
                    {partner.icon}
                    <Typography
                      variant="h5"
                      gutterBottom
                      sx={{
                        fontWeight: 700,
                        mt: 2,
                        letterSpacing: 0.5,
                        color: "#333",
                      }}
                    >
                      {partner.name}
                    </Typography>
                    <Typography
                      color="text.secondary"
                      sx={{ fontSize: "0.85rem" }}
                    >
                      {partner.description}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          )}
        </motion.div>
      </Box>
    </Box>
  );
};

export default Partners;
